import { render, staticRenderFns } from "./iconEditUser.vue?vue&type=template&id=8e70cb38&scoped=true&"
import script from "./iconEditUser.vue?vue&type=script&lang=js&"
export * from "./iconEditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e70cb38",
  null
  
)

export default component.exports